import { useTile } from '../../context'
import TileWrapper from '../TileWrapper'

import { cn } from '@/lib/utils'

const CustomImageTile = () => {
  const { tile } = useTile()
  const imageUrl = tile.config?.image_url as string | undefined
  const alt = (tile.config?.alt as string) || 'Custom image'

  if (!imageUrl) {
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No image configured.</p>
      </TileWrapper>
    )
  }

  const image = (
    <img
      src={imageUrl}
      alt={alt}
      className={cn(
        'w-full h-auto object-cover border',
        tile.config?.title ? 'rounded-b-md' : 'rounded-md',
      )}
    />
  )

  return (
    <TileWrapper className={tile.config?.title ? 'pb-0' : 'p-0 border-none'}>
      {tile.config?.url ? (
        <a
          href={tile.config.url}
          target='_blank'
          rel='noopener noreferrer'
          className={
            tile.config?.title
              ? 'block -mb-px ml-[-17px] w-[calc(100%+34px)]'
              : ''
          }
        >
          {image}
        </a>
      ) : (
        <span
          className={
            tile.config?.title
              ? 'block -mb-px ml-[-17px] w-[calc(100%+34px)]'
              : ''
          }
        >
          {image}
        </span>
      )}
    </TileWrapper>
  )
}

export default CustomImageTile
